__turbopack_context__.v({
  "teamPanel": "eew-Zq_teamPanel",
  "teamPanel__actionsCell": "eew-Zq_teamPanel__actionsCell",
  "teamPanel__memberNameCell": "eew-Zq_teamPanel__memberNameCell",
  "teamPanel__section": "eew-Zq_teamPanel__section",
  "teamPanel__sectionHeader": "eew-Zq_teamPanel__sectionHeader",
  "teamPanel__sectionMeta": "eew-Zq_teamPanel__sectionMeta",
  "teamPanel__sectionTitle": "eew-Zq_teamPanel__sectionTitle",
  "teamPanel__statusCell": "eew-Zq_teamPanel__statusCell",
});
